export default __webpack_public_path__ + "static/media/9.41c4b72f.png";